export const authenticationEmailForm = 'authenticationEmailForm';
export const authenticationPasswordForm = 'authenticationPasswordForm';
